/* eslint-disable no-unused-vars */
 
 /* eslint-disable react/no-unknown-property */
import  { useEffect } from "react"
import Glide from "@glidejs/glide"
import { Carousel } from "@material-tailwind/react";

export default function SliderIndicatorsControlsInside() {
  useEffect(() => {
    const slider = new Glide(".glide-03", {
      type: "slider",
      focusAt: "center",
      perView: 1,
      autoplay: 3000,
      animationDuration: 700,
      gap: 6,
      classes: {
        nav: {
          active: "[&>*]:bg-wuiSlate-700",
        },
      },
    }).mount()

    return () => {
      slider.destroy()
    }
  }, [])

  return (
    <>
    
    <div class="overflow-hidden">

 {/*<!-- Component: Slider with indicators & controls inside --> */}
 <div className="relative  glide-03">
        {/*    <!-- Slides --> */}
        <div className="overflow-hidden" data-glide-el="track">
          <ul className="whitespace-no-wrap flex-no-wrap [backface-visibility: hidden] [transform-style: preserve-3d] [touch-action: pan-Y] [will-change: transform] relative flex w-full overflow-hidden">
            <li>
              <img
                src="https://ik.imagekit.io/hickter/Hickter_Projects/Aasthamedihelp/Media/Banners/1.png?updatedAt=1709800642909"
                className="lg:p-[20px] md:p-5 md:p-[10px]h-auto max-w-full"
              />
            </li>
            <li>
              <img
                src="https://ik.imagekit.io/hickter/Hickter_Projects/Aasthamedihelp/Media/Banners/2.png?updatedAt=1709800643352"
                className="lg:p-[20px] w-full max-w-full max-h-full m-auto"
              />
            </li>
            <li>
              <img
                src="https://ik.imagekit.io/hickter/Hickter_Projects/Aasthamedihelp/Media/Banners/3.png?updatedAt=1709800642658"
                className="lg:p-[20px] w-full max-w-full max-h-full m-auto"
              />
            </li>
            <li>
              <img
                src="https://ik.imagekit.io/hickter/Hickter_Projects/Aasthamedihelp/Media/Banners/4.png?updatedAt=1709800644615"
                className="lg:p-[20px] w-full max-w-full max-h-full m-auto"
              />
            </li>
           
          </ul>
        </div>
        
        {/*    <!-- Controls --> */}

        <div
          className="absolute left-0 flex items-center justify-between w-full h-0 px-4 top-1/2 "
          data-glide-el="controls"
        >
          <button
            className="inline-flex items-center justify-center w-8 h-8 transition duration-300 border rounded-full border-slate-700 bg-white/20 text-slate-700 hover:border-slate-900 hover:text-slate-900 focus-visible:outline-none lg:h-12 lg:w-12"
            data-glide-dir="<"
            aria-label="prev slide"
          >
            <svg className="bg-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              // eslint-disable-next-line react/jsx-no-duplicate-props
              class="w-5 h-5"
            >
              <title>prev slide</title>
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
              />
            </svg>
          </button>
          <button
            className="inline-flex items-center justify-center w-8 h-8 transition duration-300 border rounded-full border-slate-700 bg-white/20 text-slate-700 hover:border-slate-900 hover:text-slate-900 focus-visible:outline-none lg:h-12 lg:w-12"
            data-glide-dir=">"
            aria-label="next slide"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-5 h-5"
            >
              <title>next slide</title>
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
              />
            </svg>
          </button>
        </div>
        {/*    <!-- Indicators --> */}
        <div
          className="absolute bottom-0 flex items-center justify-center w-full gap-2"
          data-glide-el="controls[nav]"
        >
          <button
            className="p-4 group"
            data-glide-dir="=0"
            aria-label="goto slide 1"
          >
            <span className="block w-2 h-2 transition-colors duration-300 rounded-full bg-white/20 ring-1 ring-slate-700 focus:outline-none"></span>
          </button>
          <button
            className="p-4 group"
            data-glide-dir="=1"
            aria-label="goto slide 2"
          >
            <span className="block w-2 h-2 transition-colors duration-300 rounded-full bg-white/20 ring-1 ring-slate-700 focus:outline-none"></span>
          </button>
          <button
            className="p-4 group"
            data-glide-dir="=2"
            aria-label="goto slide 3"
          >
            <span className="block w-2 h-2 transition-colors duration-300 rounded-full bg-white/20 ring-1 ring-slate-700 focus:outline-none"></span>
          </button>
          <button
            className="p-4 group"
            data-glide-dir="=3"
            aria-label="goto slide 4"
          >
            <span className="block w-2 h-2 transition-colors duration-300 rounded-full bg-white/20 ring-1 ring-slate-700 focus:outline-none"></span>
          </button>
        </div>
      </div>
      {/*<!-- End Slider with indicators & controls inside --> */}
      
    </div>

    </>
  )
}